import React, { useEffect, useState, memo } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  IconButton,
  Button,
  Box,
  Typography,
  Snackbar,
  Alert,
  MenuItem,
  Select,
  Checkbox,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
} from "@mui/material";
import { Add, CheckBox, Delete } from "@mui/icons-material";
import style from "../../../../styles/brsr/general.module.css";
import EastIcon from "@mui/icons-material/East";
import { getRowErrorMessages } from "../../../../utils/getRowErrorMessage";

import { validateNumber, validateNumberInput, validatePercentage } from "../../../../utils/validateFields";
import DeleteRowDialog from "../../../../Components/Common/DeleteRowDialog";

const DynamicTable = memo(
  ({ inputData, subHeading, tables, setTables, errors, setErrors,data, hide,
    letter,disabled }) => {
   useEffect(() => {
         setTables(
           inputData?.map((section) => ({
             fieldName: section?.fieldName,
             rows:
               data?.[section?.fieldName]?.length > 0
                 ? data[section?.fieldName]
                 : [{}],
           }))
         );
         console.log(tables,"h1")
   
       }, [data]);
    // useEffect(() => {
    //   setTables(
    //     inputData?.map((section) => ({
    //       fieldName: section.fieldName,
    //       rows: Array.isArray(data?.[section.fieldName]) ? data[section.fieldName] : [{}],
    //     }))
    //   );
    // }, [data]);
    
    const [fieldToRemove, setFieldToRemove] = React.useState({
      tableIndex: null,
      rowIndex: null,
    });
    const [snackOpen, setsnackOpen] = useState({
      open: false,
      message: "",
      severity: "",
    });
    const [openDialog, setOpenDialog] = React.useState(false);
     const [isFilled, setIsFilled] = useState({});

 

    const handleAddRow = (tableIndex) => {
      setTables((prev) => {
        const newTables = [...prev];
        if (!Array.isArray(newTables[tableIndex].rows)) {
          newTables[tableIndex].rows = [];
        }
        newTables[tableIndex].rows.push({});
        return newTables;
      });
    };

    const handleRemoveRow = (tableIndex, rowIndex) => {
      setTables((prev) => {
        const newTables = [...prev];
        if (
          Object.values(newTables[tableIndex].rows[rowIndex]).some((val) => val)
        ) {
          setOpenDialog(true);
          setFieldToRemove({ tableIndex, rowIndex });
          return newTables;
        }

        newTables[tableIndex].rows.splice(rowIndex, 1);
        return newTables;
      });
    };

    const cancelRemoveRow = () => {
      setOpenDialog(false);
    };
    
    const confirmRemoveRow = () => {
      if (fieldToRemove) {
        const { tableIndex, rowIndex } = fieldToRemove;
        setTables((prev) => {
          const newTables = [...prev];
          newTables[tableIndex].rows.splice(rowIndex, 1);
          return newTables;
        });
      }
      setOpenDialog(false);
    };

    const handleInputChange = (
      tableIndex,
      rowIndex,
      fieldName,
      value,
      type
    ) => {
      if (type === "percentage" && !validatePercentage(value)) return;
      if (type === "number" && !validateNumberInput(value)) return;

      const updatedTables = [...tables];
      updatedTables[tableIndex].rows[rowIndex][fieldName] = value;

      const updatedErrors = { ...errors };
      if (updatedErrors[tableIndex] && updatedErrors[tableIndex][rowIndex]) {
        delete updatedErrors[tableIndex][rowIndex][fieldName];
        if (Object.keys(updatedErrors[tableIndex][rowIndex]).length === 0) {
          delete updatedErrors[tableIndex][rowIndex];
        }
        if (Object.keys(updatedErrors[tableIndex]).length === 0) {
          delete updatedErrors[tableIndex];
        }
      }

      setErrors(updatedErrors);
      setTables(updatedTables);
      checkIfAdded();
    };

     useEffect(() => {
          checkIfAdded();
        }, [tables, inputData]); // Run only when tables or inputData change
    

    const checkIfAdded = () => {
      tables.forEach((table, tableIndex) => {
        const rows = table?.rows || [];
        const lastRow = rows.length > 0 ? rows[rows.length - 1] : {}; // Ensure lastRow is an object
        const filteredLastRow = Object.fromEntries(
          Object.entries(lastRow).filter(([key]) => key !== "_id")
        );


        const optionalLength=inputData?.[tableIndex]?.fields?.filter(el=>el?.optional)?.length;
        console.log(optionalLength,"option")
        // Check if lastRow is fully filled
        const isComplete =
          Object.keys(filteredLastRow).length >=
            (inputData?.[tableIndex]?.fields?.length-optionalLength || 0) &&
          Object.values(filteredLastRow)?.every(
            (val) =>
              val !== undefined &&
              val !== "" &&
              val !== null &&
              val?.length !== 0
          );
        console.log("complte", lastRow, isComplete);
        setIsFilled((prevState) => ({
          ...prevState,
          [tableIndex]: !isComplete, // true if incomplete, false if fully filled
        }));
      });
    };

    return (
      <Box sx={{ mt: "2rem" }}>
        <DeleteRowDialog
          {...{ openDialog, cancelRemoveRow, confirmRemoveRow }}
        />
        {/* {Heading && <p className={style.Heading}>{Heading}</p>} */}
        {subHeading && <p className={style.subHeading}>{subHeading}</p>}
        {inputData?.map((section, tableIndex) => (
          <div key={section.fieldName} sx={{ marginBottom: "1rem" }}>
           <Box sx={{display:"flex",gap:1}}>
            {section?.letter && (
              <p className={style.ques_heading}>{section.letter}</p>
            )}
            <p className={style.ques_heading}>{section.title}</p>
          </Box>
          
            <TableContainer
              component={Paper}
              sx={{
                boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                mt: 2,
                borderRadius: "10px",
              }}
            >
              <Table sx={{ border: "1px solid #ddd", borderRadius: "10px" }}>
                <TableHead>
                  <TableRow
                    sx={{
                      borderRadius: "10px",
                      backgroundColor: "#1C486B",
                      border: "1px solid #ddd",
                    }}
                  >
                    <TableCell
                      sx={{
                        border: "1px solid #ddd",
                        fontWeight: "bold",
                        color: "#FFFFFF",
                        width: "1rem",
                      }}
                    >
                      S. No.
                    </TableCell>
                    {section?.fields?.map((field) => (
                      <TableCell
                        key={field?.fieldName}
                        style={{
                          border: "1px solid #ddd",
                          fontWeight: "bold",
                          color: "#FFFFFF",
                          width: field.width,
                        }}
                      >
                        {field?.title}
                      </TableCell>
                    ))}
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                        color: "#FFFFFF",
                        width: "1rem",
                      }}
                    >
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>
               
                <TableBody>
 
                {tables[tableIndex]?.rows?.map((row, rowIndex) => {
                    return (
                    <TableRow
                        key={rowIndex}
                        sx={{
                        "& > th": {
                            color: "white",
                            fontWeight: "bold",
                            py: "0.5rem",
                            px: "0.5rem",
                            border: "1px solid rgba(224, 224, 224, 1)",
                            height: "30px",
                        },
                        }}
                    >
                        <TableCell>{rowIndex + 1}</TableCell>
                        {section?.fields?.map((field) => (
                        <TableCell
                            key={field?.fieldName}
                            sx={{ border: "1px solid #DBDBDB", py: "0.5rem" }}
                        >
                            <TextField
                            placeholder={field.placeholder}
                            type={field.type}
                            value={row[field.fieldName] || ""}
                            onChange={(e) =>
                                handleInputChange(
                                tableIndex,
                                rowIndex,
                                field.fieldName,
                                e.target.value,
                                field.type
                                )
                            }
                            multiline
                            disabled={disabled}
                            // rows={1}
                            sx={{
                                width: "100%",
                                py: "0.5rem",
                                "& .MuiInputBase-root": {
                                overflowY: "auto",
                                cursor: "default", // default cursor
                                },
                                "& .MuiInputBase-root:hover": {
                                cursor: "pointer", // pointer cursor on hover
                                },
                            }}
                            size="small"
                            variant="standard"
                            InputProps={{ disableUnderline: true }}
                            />
                        </TableCell>
                        ))}
                        <TableCell>
                        <IconButton
                            // disabled={rowIndex === 0}
                            disabled={tables[tableIndex]?.rows?.length === 1 || disabled}
                            onClick={() => handleRemoveRow(tableIndex, rowIndex)}
                            color="error"
                        >
                            <Delete />
                        </IconButton>
                        </TableCell>
                    </TableRow>
                    );
                })}

                {/* Static row for total cost */}
                <TableRow
                sx={{
                    "& > td": {
                    border: "1px solid #DBDBDB", // Ensure consistent column lines
                    py: "0.5rem",
                    backgroundColor: "#EFEFEF"
                    },
                }}
                >
                <TableCell>{/* Empty cell for Sr. No. */}</TableCell>
                <TableCell
                    colSpan={section.fields.length - 3} // Adjust colspan to span the appropriate fields
                    sx={{ fontWeight: "bold", textAlign: "left" }}
                >
                    Total
                </TableCell>
                {section.fields.slice(1).map((field, index) => (
                    <TableCell key={index}>
                    {field.fieldName === "cost"
                        ? tables[tableIndex]?.rows.reduce((total, row) => {
                            const cost = parseFloat(row.cost) || 0;
                            return total + cost;
                        }, 0)
                        : ""} {/* Add placeholders for other columns */}
                    </TableCell>
                ))}
                <TableCell sx={{ border: "1px solid #DBDBDB" }}>{/* Empty cell for actions */}</TableCell>
                </TableRow>
                </TableBody>

              </Table>
            </TableContainer>
            <Box sx={{ mt: 1, ml: 1 }}>
              {Object.keys(errors).length > 0 &&
                getRowErrorMessages(tableIndex, inputData, tables, errors).map(
                  (errorMessage, idx) => (
                    <p
                      key={idx}
                      color="error"
                      variant="caption"
                      style={{
                        lineHeight: "1.2",
                        margin: "2px 0",
                        color: "#d34040",
                        fontSize: "10px",
                        fontStyle: "italic",
                      }}
                    >
                      {errorMessage}
                    </p>
                  )
                )}
            </Box>
            {/* Add row button */}
            {!hide &&
            <Box sx={{ display: "flex", justifyContent: "flex-end", marginTop:"-0.5rem"}}>
              <Button
                disabled={isFilled?.[tableIndex] || disabled}
                endIcon={<Add />}
                onClick={() => handleAddRow(tableIndex)}
                sx={{
                  marginTop: "1rem",
                  color: "#1C486B",
                  width: "7rem",
                  borderColor: "#1C486B",
                }}
                variant="outlined"
              >
                Add
              </Button>
            </Box>
    }
            {/* Dynamic error messages for missing fields */}
          </div>
        ))}
      </Box>
    );
  }
);

export default DynamicTable;
